import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../core/api.service';
import { FunctionsService } from '../../core/global/functions.service';
import { UtilityService } from '../../core/global/utility.service';
@Component({
  selector: 'app-gate-add-model',
  templateUrl: './gate-add-model.component.html',
  styleUrls: ['./gate-add-model.component.sass']
})
export class GateAddModelComponent implements OnInit {
  public defaultUpdateId = '';
  addGateObj: any = {};
  orgList = []
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  updateId = '';
  orgName = [];
  password;
  show = false;
  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }

  ngOnInit(): void {
    this.updateId = window.localStorage.getItem('pushGateId');
    window.localStorage.removeItem('pushGateId');
    this.password = 'text';
    this.addGateObj.gate_userName = ''
    this.addGateObj.pass = ''
    if (this.updateId) {
      this.getGateDetails()
    }
    this.getOrg()
  }
  onClick() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }
  getOrg() {
    let wheredata = []
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/org_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.orgList = response.data
      }
    })
  }
  getGateDetails() {
    let wheredata = []
    wheredata = [{ 'field': '`qr_gate`.`id`', 'value': this.updateId, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/gate_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.addGateObj.gate_name = response.data[0].gate_name
        this.addGateObj.gate_userName = response.data[0].user_name
        this.addGateObj.pass = response.data[0].gate_password
        let org_id = response.data[0].org_ref_id.split(',')
        let lent = response.data[0].org_ref_id.split(',').length;
        let org_ids = [];
        if (lent > 0) {
          for (let i = 0; i < lent; i++) {
            org_ids.push(parseInt(org_id[i]));
            if (i == (lent - 1)) {
              this.addGateObj.org_ref_id = org_ids;
            }
          }
        }
        this.onOrgChange(this.addGateObj.org_ref_id)
      }
    })
  }
  onOrgChange(event) {
    this.orgName = []
    for (let i = 0; i < this.orgList.length; i++) {
      for (let j = 0; j < event.length; j++) {
        if (this.orgList[i].id == event[j]) {
          this.orgName.push(this.orgList[i].org_name)
        }
      }
    }
  }
  save() {
    var error = 0;
    this.addGateObj.org_name = this.orgName
    if (!this.addGateObj.gate_name) {
      error++;
      this._utility.toastWarning('Enter Gate Name');
    }
    else if (!this.addGateObj.org_ref_id) {
      error++;
      this._utility.toastWarning('Select Organization');
    }
    else if (!this.addGateObj.gate_userName) {
      error++;
      this._utility.toastWarning('Enter Username');
    }
    else if (!this.addGateObj.pass) {
      error++;
      this._utility.toastWarning('Enter password');
    }
    if (this.addGateObj.pass != '') {
      this.addGateObj.gate_password = this.addGateObj.pass
    }
    if (error == 0) {
      let url = 'qr/gate_save';
      if (this.updateId != '') {
        this.addGateObj.updateId = this.updateId;
      }
      this._adminService.post(url, this.addGateObj).subscribe((response) => {
        if (response.success == true) {
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }

}
